import * as React from "react";
import UsersTab from "../../IDMS/Tabs/UsersTab";

const AdminUserManagement: React.FC = () => {
    return UsersTab({hubOrIdmsLevel: "Hub"});
}

export default AdminUserManagement;